import { Injectable } from '@angular/core';
import {AppSettings} from "../../proyect.conf";
import {HttpClient} from "@angular/common/http";
import {AutenticacionService} from "./autenticacion.service";
import {map} from "rxjs/operators";
import {
  FlujoVentaPasoAutorizacionTipoProductoBancario
} from "../_models/flujo-venta-paso-autorizacion-tipo-producto-bancario";
import {ProductoSubdestinoMontoAliado} from "../_models/producto-subdestino-monto-aliado";

@Injectable({
  providedIn: 'root'
})
export class FlujoVentaPasoAutorizacionTipoProductoBancarioService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/flujoVentaPasosAutorizacionesTiposProductosBancarios';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as FlujoVentaPasoAutorizacionTipoProductoBancario[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as FlujoVentaPasoAutorizacionTipoProductoBancario[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as FlujoVentaPasoAutorizacionTipoProductoBancario ) );
  }

  obtenerPorIdFlujoVentaPasoAutorizacion( idFlujoVentaPasoAutorizacion: string ) {
    return this.httClient.get( this.rutServicio + '/idFlujoVentaPasoAutorizacion/' + idFlujoVentaPasoAutorizacion + '/enabled' ).pipe( map( res => res as FlujoVentaPasoAutorizacionTipoProductoBancario[] ) );
  }

  bulk( regActualizar: FlujoVentaPasoAutorizacionTipoProductoBancario[] ) {
    regActualizar.map( ( s: FlujoVentaPasoAutorizacionTipoProductoBancario ) => {
      s.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    } );
    return this.httClient.post( this.rutServicio + '/bulk', regActualizar  ).pipe( map( res => res as any ) );
  }
}
